import independentSamplingReducer from "./independentSamplingReducer";
import violationReducer from "./violationReducer";
import irregularApplicationReducer from "./irregularApplicationReducer";

const irregularApplicationReducers = {
    independentSampling : independentSamplingReducer,
    violation : violationReducer,
    irregularApplication: irregularApplicationReducer,
}

export default irregularApplicationReducers;